
import { Component, Vue, Mixins } from 'vue-property-decorator'
import Default from './Default.vue'
import { Component as SlideComponent } from '../../@types/Slide'

@Component
export default class Focus extends Mixins(Default) {
  /**
   * Block.
   */
  get blocks() {
    const [block] = this.slide.blocks
    return [
      this.isComponent(block)
        ? this.toVueComponent(block as SlideComponent)
        : block
    ]
  }
}
